import { graphql } from "gql";
import { useQueryWithSnack } from "utils/useQueryWithSnack";

export const GET_SYSTEM_INFORMATION = graphql(`
  query GetSystemInformation {
    systemInformation {
      environment
      version
    }
  }
`);

export const getEnvironment = () => {
  const { data } = useQueryWithSnack(GET_SYSTEM_INFORMATION);

  const environment = data?.systemInformation.environment;

  const uvdLoginInfoUrl =
    "https://blue-ocean-robotics.atlassian.net/wiki/spaces/SIR/pages/2082177214/Useful+commands+and+tricks#UVD-login";

  return { environment, uvdLoginInfoUrl };
};
